import { NgModule } from '@angular/core';
import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

@Directive({
    selector: '[fghoverTopnavDropDown]',
    standalone: false
})

export class FgHoverDropDownTopnavDirective implements OnInit {

    isInHoverBlock = false;

    constructor(private el: ElementRef) { }

    @Input() hoverTrigger: MatMenuTrigger;
    @Input() menu: any;
    @Input() component: any = {}

    ngOnInit() {
        if (!this.component?.hoverMenuEnabled) return;

        this.el.nativeElement.addEventListener('mouseenter', () => {
            this.setHoverState(true);
            this.hoverTrigger.openMenu();

            setTimeout(() => {
                const openMenu = document.querySelectorAll(`.mat-menu-after, .fg-top-nave-menu-item`);
                if (!openMenu[0]) {
                    this.hoverTrigger.closeMenu();
                    return;
                }
                openMenu[0].addEventListener('mouseenter', () => {
                    this.setHoverState(true);
                });
                openMenu[0].addEventListener('mouseleave', () => {
                    this.setHoverState(false);
                });
            }, 100);
        });

        this.el.nativeElement.addEventListener('mouseleave', () => {
            this.setHoverState(false);
        });
    }

    private setHoverState(isInBlock: boolean) {
        this.isInHoverBlock = isInBlock;
        if (!isInBlock) {
            this.checkHover();
        }
    }

    private checkHover() {
        setTimeout(() => {
            if (!this.isInHoverBlock && this.hoverTrigger.menuOpen) {
                this.hoverTrigger.closeMenu();
            }
        }, 50);
    }
}